<template>
  <div class="system-mian">
    <el-scrollbar>
      <div style="">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item label="是否停止系统" prop="state">
            <el-radio-group v-model="form.state">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-button
          v-if="readonlys"
          type="primary"
          size="small"
          style="margin-left: 105px"
          @click="_modify"
        >修改</el-button>
        <el-button
          v-if="readonlys"
          type="primary"
          size="small"
          @click="form.state = old"
        >重置</el-button>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      readonlys: true,
      saveState: true,
      old: '',
      form: {
        state: ''
      }
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '004002001') {
        this.saveState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.$httpPost('BasicInformation/System/GetSystemState', {}).then(
        (res) => {
          // console.log(res, "res");
          this.form.state = res.datalist
          this.old = this.form.state
        }
      )
    },
    _modify() {
      this.$confirm('是否保存修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$httpPost('BasicInformation/System/SaveSystemState', {
            state: this.form.state
          }).then((res) => {
            // console.log(res, 'res')
            if (res.isSuccess) {
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
              throw res.message
            }
          })
        })
        .catch(() => {
          this.refresh()
          this.readonlys = true
          this.$message({
            type: 'info',
            message: '已取消修改'
          })
        })
    }
  }
}
</script>
<style lang='less'>
.system-mian {
  height: calc(100vh - 150px);
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
}
</style>
